// Shared session formatting utilities
// Extracted from SessionListCards.vue for reusability across components
import { humanTimeAgo } from '@/lib/humanTimeAgo';
/**
 * Format session total lines count
 * Returns empty string if 0, otherwise returns "[N]"
 */
export function formatSessionTotalLines(session) {
    if (session.totalLines === 0) {
        return '';
    }
    return `[${session.totalLines}]`;
}
/**
 * Check if session has gems
 */
export function hasGems(session) {
    return !!session.hasGems;
}
/**
 * Format session createdAt in YY-MM-DD HH:MM format
 * Example: "25-12-18 14:30"
 */
export function formattedCreatedAt(session) {
    if (!session.createdAt)
        return '{missing}';
    const utcDate = new Date(session.createdAt);
    const formatter = new Intl.DateTimeFormat(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const parts = formatter.formatToParts(utcDate);
    const map = Object.fromEntries(parts.map(p => [p.type, p.value]));
    return `${map.year}-${map.month}-${map.day} ${map.hour}:${map.minute}`;
}
/**
 * Format session info as human-readable time ago
 * Examples: "2 hours ago", "yesterday morning", "last Monday evening"
 */
export function formatSessionInfoHumanTimeAgo(session) {
    if (!session.createdAt)
        return 'missing info';
    const date = new Date(session.createdAt);
    return humanTimeAgo(date);
}
/**
 * Check if session was created today
 */
export function isFromToday(session) {
    if (!session.createdAt)
        return false;
    const now = new Date();
    const created = new Date(session.createdAt);
    return (created.getFullYear() === now.getFullYear() &&
        created.getMonth() === now.getMonth() &&
        created.getDate() === now.getDate());
}
